import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function SaveStorewiseAsinForAssetsService(token,data) {
    return axios.post(`${CURRENT_API_URL}/contentmanagement/saveStorewiseAsinForAsset`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        console.log(res.data)
        notify.NotifySuccess("Asset Asin added successfully.");
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while adding asset Asin, please try again later.");
        return false;
    });
}

export default SaveStorewiseAsinForAssetsService;